import { render, staticRenderFns } from "./br-BR.vue?vue&type=template&id=1251b560&scoped=true&"
var script = {}
import style0 from "./br-BR.vue?vue&type=style&index=0&id=1251b560&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1251b560",
  null
  
)

export default component.exports